/**
 * Requires
 */

import $ from 'jquery'

let offset = 0
let openState = false
//     let value = $(`[data-tickets-options] option[data-tickets-id=${ticketRef}]`).val()
/**
 * Initialisation
 */

export function initialise() {
  updateOverviewHeight()
}

function updateOverviewHeight() {
  setTimeout(function() {
    const $showAccordionButton = $('[data-toggle-accordion-item]')

    $showAccordionButton.on('click', function() {
      const $this = $(this)
      const id = $this.data('toggle-accordion-item')
      const $target = $('[accordion-item="' + id + '"]')
      const $targetHeight = $('[data-toggle-target-accordion-item="' + id + '"]').height()

      if ($this.hasClass('open')) {
        $target.css('max-height', `calc(${$targetHeight}px + 132px)`)
      } else {
        $target.css('max-height', `100px`)
      }
    })
  }, 200)
}
